import { Component, Input } from '@angular/core';

@Component({
  selector: 't-icon',
  templateUrl: './icon.component.html'
})
export class IconComponent {
  @Input() name: string = '';
  @Input() class: string = '';
  @Input() title: string = '';
}